import React, { useMemo } from 'react';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import Button from '../../components/shared/buttons/Button';
import Row from '../../components/shared/table/Row';
import SelectableRow from '../../components/shared/table/SelectableRow';
import Table from '../../components/shared/table/Table';
import { formatTime } from '../../utils/formatter';

const TasksTable = ({ tasks, loading, onTaskClick, onTaskDeleteClick, readOnly }) => {
  const tableRows = useMemo(
    () =>
      tasks.map((task, i) => (
        <SelectableRow key={i} onClick={() => onTaskClick(task)}>
          <Row children={task.name} />
          <Row children={formatTime(task.hours)} />
          {!readOnly && (
            <Row
              children={
                <div title="Видалити" className="w-full text-end z-10">
                  <Button
                    onClick={(event) => {
                      event.stopPropagation();
                      onTaskDeleteClick(task);
                    }}
                    variant="secondary2"
                    disabled={loading}
                  >
                    <MdOutlineDeleteOutline size={20} />
                  </Button>
                </div>
              }
            />
          )}
        </SelectableRow>
      )),
    [readOnly, onTaskDeleteClick, loading, tasks, onTaskClick],
  );

  return <Table columns={readOnly ? readOnlyColumns : columns} data={tableRows} onRowClick={() => ({})} />;
};

const readOnlyColumns = [
  { name: 'Назва', className: 'w-[85%]' },
  { name: 'н/г', className: 'w-[15%]' },
];

const columns = [
  { name: 'Назва', className: 'w-[80%]' },
  { name: 'н/г', className: 'w-[15%]' },
  { name: 'Дії', className: 'w-[5%] text-center' },
];

export default TasksTable;
